const cardsData = [
  {
    title: '动作冒险',
    desc: '热血激战·超燃打斗',
    count: '2.3万部',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20aesthetic%20with%20dramatic%20warm%20amber%20and%20crimson%20lighting%2C%20abstract%20motion%20energy%20in%20dark%20setting%2C%20sleek%20modern%20film%20poster%20style%2C%20intense%20dynamic%20composition%20with%20cinematic%20glow%2C%20elegant%20theater%20atmosphere%2C%20rich%20contrast%2C%20professional%20movie%20genre%20visual&width=800&height=500&seq=card-action&orientation=landscape',
    icon: 'ri-sword-line',
  },
  {
    title: '喜剧剧场',
    desc: '爆笑不断·欢乐时光',
    count: '1.8万部',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cheerful%20cinematic%20atmosphere%20with%20golden%20amber%20lighting%2C%20soft%20bokeh%20highlights%20on%20dark%20velvet%20background%2C%20elegant%20comedy%20film%20genre%20visual%2C%20bright%20warm%20spotlight%20effects%2C%20sophisticated%20movie%20theater%20mood%2C%20rich%20golden%20tones%20with%20deep%20shadows%2C%20no%20people&width=800&height=500&seq=card-comedy&orientation=landscape',
    icon: 'ri-emotion-happy-line',
  },
  {
    title: '悬疑推理',
    desc: '烧脑剧情·反转不断',
    count: '1.2万部',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20cinematic%20scene%20with%20deep%20shadowy%20composition%2C%20dramatic%20chiaroscuro%20lighting%20in%20amber%20and%20warm%20brown%20tones%2C%20enigmatic%20film%20noir%20atmosphere%2C%20sophisticated%20suspense%20genre%20visual%2C%20elegant%20dark%20theater%20mood%20with%20subtle%20golden%20highlights%2C%20rich%20textured%20shadows&width=800&height=500&seq=card-mystery&orientation=landscape',
    icon: 'ri-search-eye-line',
  },
  {
    title: '科幻巨制',
    desc: '未来视界·想象无限',
    count: '0.9万部',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20cinematic%20atmosphere%20with%20deep%20navy%20and%20warm%20amber%20contrast%20lighting%2C%20abstract%20cosmic%20energy%20visual%2C%20elegant%20science%20fiction%20film%20genre%20style%2C%20sophisticated%20space%20themed%20composition%20with%20golden%20light%20beams%2C%20dark%20rich%20background%2C%20cinematic%20glow%20effects&width=800&height=500&seq=card-scifi&orientation=landscape',
    icon: 'ri-rocket-line',
  },
  {
    title: '综艺娱乐',
    desc: '欢乐不停·精彩纷呈',
    count: '0.7万部',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20cinematic%20stage%20lighting%20with%20warm%20golden%20and%20amber%20spotlights%2C%20elegant%20entertainment%20show%20atmosphere%2C%20rich%20velvet%20curtains%20in%20deep%20warm%20tones%2C%20sophisticated%20variety%20show%20visual%2C%20dramatic%20theater%20lighting%20effects%20on%20dark%20background%2C%20glamorous%20stage%20aesthetic&width=800&height=500&seq=card-variety&orientation=landscape',
    icon: 'ri-live-line',
  },
  {
    title: '动漫精选',
    desc: '热血青春·经典重温',
    count: '1.5万部',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20cinematic%20composition%20with%20warm%20sunset%20amber%20and%20soft%20pink%20gradient%20lighting%2C%20elegant%20animation%20film%20genre%20visual%20style%2C%20dreamy%20atmospheric%20scene%20with%20golden%20bokeh%2C%20sophisticated%20anime%20aesthetic%20with%20rich%20warm%20tones%2C%20dark%20elegant%20background&width=800&height=500&seq=card-anime&orientation=landscape',
    icon: 'ri-palette-line',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full mb-3 whitespace-nowrap">
              海量片库
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              精选分类
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
              六大热门分类，满足你的所有观影口味
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {cardsData.map((card) => (
              <article key={card.title} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={card.image}
                    alt={`成全影院${card.title}分类`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  <div className="absolute bottom-3 left-4 flex items-center gap-2">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
                      <i className={`${card.icon} text-white text-xs`}></i>
                    </div>
                    <span className="text-white/90 text-xs font-medium whitespace-nowrap">{card.count}</span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1">{card.title}</h3>
                  <p className="text-sm text-foreground-500">{card.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}